import { FC } from 'react';
import { ITechnologyStack } from '@components/projects/level01/level01.state';
import styles from './technology-stack.module.scss';
import Image from 'next/image';
import parse from 'html-react-parser';
import Level01Animation from '@components/projects/level01/animations';
import animations from '@components/projects/level01/animations/animations.module.scss';

interface TechnologyStackSectionProps {
    section: ITechnologyStack;
}

const TechnologyStackSection: FC<TechnologyStackSectionProps> = ({ section }) => {
    const itemWithWrapTitle: string = 'Encrypted database';
    return (
        <Level01Animation render={(ref) => (
          <div className={styles.container}>
            <section ref={ref} className={`${styles.section} ${animations.scroll__animation}`}>
              <h2 className={styles.section__title}>{section.title}</h2>
              <div className={styles.section__blocks}>
                {section.blocks.map((block) => (
                  <div className={styles.section__block} key={block.title}>
                    <h3 className={styles.section__block_title}>{block.title}</h3>
                    <div className={styles.section__block_technologies}>
                      {block.icons.map((item) => {
                        const withWordsWrapping = item.iconName === itemWithWrapTitle;
                        const additionalClasses = withWordsWrapping ? styles.words_wrap : '';
                        return (
                          <div
                            className={`${styles.section__block_technology} ${additionalClasses}`}
                            style={{ width: item.containerWidth }}
                            key={item.iconName}>
                            <Image
                              src={item.iconUrl}
                              alt={item.iconName}
                              width={item.iconWidth}
                              height={item.iconHeight}
                              layout={'fixed'}/>
                            <p>{parse(item.iconName)}</p>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                ))}
              </div>
            </section>
          </div>
        )}/>
    )
}

export default TechnologyStackSection;
